
import {PIXELS_PER_METER} from "@/dungeons/geometry/Coordinates.ts";


export const CharacterSizes = new Map<string, number>([
    ["Winzig", PIXELS_PER_METER * 0.75],
    ["Winziges", PIXELS_PER_METER * 0.75],
    ["Klein", PIXELS_PER_METER * 1.5],
    ["Kleines", PIXELS_PER_METER * 1.5],
    ["Mittelgroß", PIXELS_PER_METER * 1.5],
    ["Mittelgroßes", PIXELS_PER_METER * 1.5],
    ["Groß", PIXELS_PER_METER * 3],
    ["Großes", PIXELS_PER_METER * 3],
    ["Riesig", PIXELS_PER_METER * 4.5],
    ["Riesiges", PIXELS_PER_METER * 4.5],
    ["Gigantisch", PIXELS_PER_METER * 6],
]);


export const CharacterSizeOptions = () => {
    const options = [];
    for (const key of CharacterSizes.keys()) {
        options.push(key);
    }
    return options;
}
